import React from 'react'
import Panel from './Panel'

export const wrapPageElement = ({ element }, pluginOptions) => (
  <>
    {element}
    <Panel {...pluginOptions} />
  </>
)
